export const filterObjToGetUrl = function (url, filters) {
  var paramsString = "";
  for (var property in filters) {
    paramsString =
      paramsString +
      property +
      "=" +
      encodeURIComponent(filters[property]) +
      "&";
  }
  paramsString = paramsString.slice(0, -1);
  let completeUrl;
  if (url.includes("?")) {
    completeUrl = url + "&" + paramsString;
  } else {
    completeUrl = url + "?" + paramsString;
  }
  return completeUrl;
};
